"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuffix = void 0;
var _escapeRegExp = require("./escapeRegExp");
const getSuffix = (value, {
  groupSeparator = ',',
  decimalSeparator = '.'
}) => {
  const suffixReg = new RegExp(`\\d([^${(0, _escapeRegExp.escapeRegExp)(groupSeparator)}${(0, _escapeRegExp.escapeRegExp)(decimalSeparator)}0-9]+)`);
  const suffixMatch = value.match(suffixReg);
  return suffixMatch ? suffixMatch[1] : undefined;
};
exports.getSuffix = getSuffix;